import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImportApiObjectsService {
  constructor(public rest: RestService) {}

  uploadApiObjectFile(file: File, projectId: string, projectIdDb2: string, createStep: boolean, stepName: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('projectId', projectId);
    formData.append('projectIdDb2', projectIdDb2);
    formData.append('createStep', createStep.toString());
    formData.append('stepName', stepName);
    
    return this.rest.post("importApiObjects", formData);
  }
}